module.exports = __webpack_public_path__ + "static/media/bg.dee5f6e0.jpg";